export default __webpack_public_path__ + "static/cv-2a5789560edce356e69d3f0444f79ecc.svg";